export const METRO_CARD_NUMBER_SECTION_LIST = [
  {
    name: 'store',
    minLength: 1,
    maxLength: 3,
  },
  {
    name: 'customer',
    minLength: 1,
    maxLength: 8,
  },
  {
    name: 'cardholder',
    minLength: 1,
    maxLength: 2,
  },
  {
    name: 'service',
    minLength: 1,
    maxLength: 1,
  },
];

export const METRO_CARD_NUMBER_DELIMITER = '-';
